// on choose vumatel fibre plan page load.
export const tagOnVumatelPageLoad = (product_id, price) => {
    window.MyTIQ && window.MyTIQ.view({
        service_application_event: "start",
        service_application_step: "myvodacom: fibre: vuma reach: plan details",
        page_event: "view",
        service_application_name: "myvodacom: fibre: vuma reach sales (transaction)",
        service_application_type: "transaction",
        page_name: "myvodacom: fibre: vuma reach sales: plan details",
        sales_event: "view",
        sales_product_category: ['Fibre'],
        sales_product_id: [product_id], //(product/service name e.g "50 GB Capped")
        sales_product_quantity: '1',
        sales_product_price: [price]
    });
}

// when user confirms vumatel address.
export const tagOnVumatelAddressConfirmation = () => {
    window.MyTIQ && window.MyTIQ.view({
        service_application_step: "myvodacom: fibre: vuma reach: plan details: confirm where to deliver",
        page_event: "view",
        service_application_name: "myvodacom: fibre: vuma reach sales (transaction)",
        service_application_type: "transaction",
        page_name: "myvodacom: fibre: vuma reach: plan details: confirm where to deliver"
    });
}

// When user starts to clicks to set prefered any payment method, set below event: 
export const tagOnSetVumareachPreferredPaymentMethod = () => {
    window.MyTIQ && window.MyTIQ.view({
        service_application_step: "myvodacom: fibre: vuma reach: plan details: choose preferred payment method",
        page_event: "view",
        service_application_name: "myvodacom: fibre: vuma reach sales (transaction)",
        service_application_type: "transaction",
        page_name: "myvodacom: fibre: vuma reach: plan details: choose preferred payment method",
    });
}

// When user selects payment date: 
export const tagOnVumatelPaymentDate = () => {
    window.MyTIQ && window.MyTIQ.link({
        service_application_step: "myvodacom: fibre: vuma reach: plan details: choose preferred payment date",
        service_application_name: "myvodacom: fibre: vuma reach sales (transaction)",
        service_application_type: "transaction",
    });
}

// When Vumatel contact information page is loaded. 
export const tagOnVumatelContactPageLoad = () => {
    window.MyTIQ && window.MyTIQ.view({
        service_application_step: "myvodacom: fibre: vuma reach: finalise your order",
        page_event: "view",
        service_application_name: "myvodacom: fibre: vuma reach sales (transaction)",
        service_application_type: "transaction",
        page_name: "myvodacom: fibre: vuma reach: finalise your order"
    });
}

// When Vumatel contact information page is loaded. 
export const tagOnVumatelErrorPopup = errorMessage => {
    window.MyTIQ && window.MyTIQ.view({
        page_form_event: "error",
        page_errors: [errorMessage],
        page_name: "myvodacom: fibre: vuma reach: journey error"
    });
}

// When Vumatel contact information page is loaded. 
export const tagOnVumatelSuccessPageLoad = (refId, product_name, product_price) => {
    window.MyTIQ && window.MyTIQ.view({
        service_application_event: "finish",
        service_application_step: "myvodacom: fibre: vuma reach: sales success",
        page_event: "view",
        service_application_name: "myvodacom: fibre: vuma reach sales (transaction)",
        service_application_type: "transaction",
        page_name: "myvodacom: fibre: vuma reach: sales success",
        sales_event: "fibre_available, purchase",
        sales_order_id: [refId],
        sales_product_category: ['Fibre'],
        sales_product_id: [product_name],
        sales_product_quantity: '1',
        sales_product_price: [product_price],
        sales_payment_method: "insert preferred payment method i.e. Fibre Voucher or Monthly Debit",
        sales_authentication_method_type: "insert ID or Passpoart",
    });
}

